import i18n from 'i18next';

import getTimeZoneSelectOptions from '../helpers/getTimeZoneSelectOptions';

export default ({ adminSettings, hasPreview }) =>
  hasPreview
    ? {
        time_zone: {
          type: 'Select',
          selectProps: { isFluid: true, isFullWidth: true },
          options: getTimeZoneSelectOptions({ adminSettings }),
        },
      }
    : {
        file_url: {
          type: 'Upload',
          label: i18n.t('upload-csv-file-label'),
          help: i18n.t('upload-csv-file-help'),
          hasIcon: true,
          hasReplaceUploadButton: true,
          icon: 'upload',
          iconPosition: 'left',
          maxUploadSize: 10,
          permittedFormats: '.csv',
          replaceUploadButtonText: i18n.t('upload-a-different-file'),
          uploadButtonText: i18n.t('upload-file'),
          uploadType: 'document',
          validators: [{ type: 'isRequired' }],
        },
      };
